<div class="template-modal">
  <div class="modal-header">
    <div class="title-section">
      <span class="icon">📝</span>
      <h3>Quick Insert Template</h3>
    </div>
    <button class="close-btn" (click)="onCancel()">×</button>
  </div>

  <div class="search-section">
    <input 
      type="text" 
      placeholder="Search templates..."
      [(ngModel)]="searchQuery"
      (input)="onSearch()"
      class="search-input"
      #searchInput
    >
  </div>

  <div class="templates-list">
    <div class="section-header" *ngIf="recentTemplates.length > 0 && !searchQuery">
      <h4>Recently Used</h4>
    </div>
    
    <div class="template-item" 
         *ngFor="let template of displayTemplates" 
         (click)="selectTemplate(template)"
         [class.selected]="selectedTemplate?._id === template._id">
      <div class="template-header">
        <h5 class="template-name">{{ template.name }}</h5>
        <div class="template-meta">
          <span [class]="getChannelBadgeClass(template.template_type)">
            {{ getChannelDisplayName(template.template_type) }}
          </span>
        </div>
      </div>
      <p class="template-preview">{{ template.body }}</p>
      <div class="template-variables" *ngIf="template.variables.length > 0">
        <span class="variable-chip" *ngFor="let variable of template.variables">
          {{variable}}
        </span>
      </div>
    </div>

    <div class="empty-state" *ngIf="displayTemplates.length === 0 && !isLoading">
      <p *ngIf="searchQuery">No templates found matching "{{ searchQuery }}"</p>
      <p *ngIf="!searchQuery">No templates available</p>
    </div>

    <div class="loading-state" *ngIf="isLoading">
      <div class="spinner"></div>
      <p>Loading templates...</p>
    </div>
  </div>

  <div class="modal-actions">
    <button class="cancel-btn" (click)="onCancel()">
      Cancel
    </button>
  </div>
</div>